define('app/sdc/bar/graph/sdc-bar-graph',[], function () {
	return [function () {
		return {

		}
	}];
});
